'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.orderDetailHeaderComponent = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var orderDetailHeaderComponent = exports.orderDetailHeaderComponent = {
    template: require('./order-detail-header.html'),
    bindings: {
        order: '<',
        setOrderDeliveryDate: '&',
        updatingOrderDate: '<',
        updateOrderDeliverDateErrors: '<'
    },
    controllerAs: 'vm',
    controller: ["config", "authService", "$stateParams", "$state", "cartService", "gettextCatalog", "toastr", function orderOverviewController(config, authService, $stateParams, $state, cartService, gettextCatalog, toastr) {
        'ngInject';

        var vm = this;
        vm.getDownloadUrl = getDownloadUrl;
        vm.onSetOrderDelivery = onSetOrderDelivery;
        vm.showRequestOrderDate = showRequestOrderDate;
        vm.orderProductsAgain = orderProductsAgain;
        vm.buttonDisabled = buttonDisabled;
        vm.maxDate = (0, _moment2.default)(vm.order.deliveryDate).format('DD/MM/YYYY');
        vm.minDate = (0, _moment2.default)().add(1, 'days').format('DD/MM/YYYY');
        vm.newOrderDate = vm.order.deliveryDate;
        vm.isAddingToCart = false;

        vm.forms = [];

        function getDownloadUrl(order) {
            return config.webApiBaseUrl + ('report/orderDetail/' + order.id + '?lang=' + $stateParams.language + '&access_token=' + authService.accessToken);
        }

        function onSetOrderDelivery(newDeliveryDate) {
            vm.setOrderDeliveryDate({ $event: newDeliveryDate });
        }

        function showRequestOrderDate() {
            return vm.order.orderStatusCode === 'CREATED' && (0, _moment2.default)(vm.order.deliveryDate).isAfter((0, _moment2.default)().add(1, 'days')) || (0, _moment2.default)(vm.order.deliveryDate).isSame((0, _moment2.default)().add(1, 'days')) && vm.order.deliveryDate;
        }

        function buttonDisabled() {
            return vm.forms.requestOrderDate.$error.maxDate || vm.forms.requestOrderDate.$error.minDate || !vm.newOrderDate || (0, _moment2.default)(vm.order.deliveryDate).format('DD/MM/YYYY') === (0, _moment2.default)(vm.newOrderDate).format('DD/MM/YYYY');
        }

        function orderProductsAgain() {
            vm.isAddingToCart = true;
            cartService.reOrderProducts(vm.order.id).then(function () {
                vm.isAddingToCart = false;

                toastr.success(gettextCatalog.getString('Added products to your shoppingcart'), '', {
                    progressBar: true,
                    timeOut: 5000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });

                $state.go('cart');
            }).catch(function () {

                toastr.error(gettextCatalog.getString('An error occured when adding products to your shoppingcart, please try again'), '', {
                    progressBar: true,
                    timeOut: 5000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });

                vm.isAddingToCart = false;
                vm.errors.shoppingCartAdd = true;
            });
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/components/order-detail-header.js
// module id = 842
// module chunks = 0